// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationSatisfactionNegativePath = 'M65.4 14.823A25.881 25.881 0 0052.315 9.21L48.8 0l-3.184 9.218a25.884 25.884 0 00-13.09 5.666L23.5 10.5l4.261 9.5a25.857 25.857 0 00-4.664 12.743L12.8 36.3 23 40.195v10.581L12.8 54.3 23 58.195V70H10v7h2.5a3.4 3.4 0 013.4 3l2.3 11.1a10.5 10.5 0 0010.3 8.9h43a10.5 10.5 0 0010.3-8.9l2.3-10.9V80a3.4 3.4 0 013.4-3H90v-7H75V58.118L85 54.3l-10-3.454V40.117L85 36.3l-10.09-3.486a25.86 25.86 0 00-4.847-13.06L74.3 10.5l-8.9 4.323zM68 70V35c0-7.145-3.943-13.368-9.772-16.613 1.43 2.463 2.272 5.54 2.272 8.913V70H68zM37.5 27.3c0-3.373.843-6.45 2.272-8.913C33.943 21.632 30 27.855 30 35v35h7.5V27.3zm7 0V70h9V27.3c0-4.4-2.4-7.8-4.5-7.8s-4.5 3.4-4.5 7.8zM22.8 78.9L25.1 90a3.4 3.4 0 003.4 3h43a3.4 3.4 0 003.4-3v-.2l2.2-10.9c.075-.644.209-1.28.4-1.9H22.4c.191.62.325 1.256.4 1.9z';
var IllustrationSatisfactionNegative = baseIllustration('IllustrationSatisfactionNegative', {
  getPath: () => IllustrationSatisfactionNegativePath
}, 'ColoredIllustrationSatisfactionNegative');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationSatisfactionNegative;
//# sourceMappingURL=index.js.map